<template>
  <div class="row" style="margin-bottom: 1%">
    <div class="col-md-6">
      <label>Nome do Paciente</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" disabled v-model="paciente.nome" />
      </div>
    </div>
    <div class="col-md-6">
      <label>Situação do Atendimento</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" disabled v-model="agendamentoMedico.situacao" />
      </div>
    </div>
  </div>
  <div class="row" style="margin-bottom: 1%">
    <div class="col-md-1">
      <label>Idade</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" disabled v-model="paciente.idade" />
      </div>
    </div>
    <div class="col-md-3">
      <label>Tipo de Paciente</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" disabled v-model="paciente.tipoPaciente" />
      </div>
    </div>
    <div class="col-md-4">
      <label title="Centro de Saúde Integral do Policial Militar">Resultado CSI</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" disabled />
      </div>
    </div>
    <div class="col-md-4">
      <label>Resultado Juntada Médica</label>
      <div class="input-group input-focus">
        <input type="text" class="form-control form-input-component" disabled />
      </div>
    </div>
  </div>

  <div class="row container horizontal-center" style="margin-top: 2%; margin-bottom: 2%">
    <div class="col col-icon" @click="openDialogPac()">
      <i class="fa-sharp fa-solid fa-computer icons-list"></i>
      <div class="row">
        <span style="text-align: center">Cadastro de Paciente</span>
      </div>
    </div>
    <div class="col col-icon" @click="openDialogInsercaoDados">
      <i class="fa-sharp fa-solid fa-file-medical icons-list"></i>
      <div class="row">
        <span>Dados Médicos de Inserção</span>
      </div>
    </div>
    <div class="col col-icon" @click="abrirFuncoes">
      <i class="fa-sharp fa-solid fa-user-gear icons-list"></i>
      <div class="row">
        <span style="text-align: center">Outras funções desempenhadas na PM</span>
      </div>
    </div>
    <div class="col col-icon" @click="abrirRepasse">
      <i class="fa-solid fa-right-left icons-list"></i>

      <div class="row">
        <span style="text-align: center">Repasse de Paciente</span>
      </div>
    </div>
    <div class="col col-icon">
      <i class="fa-sharp fa-solid fa-file-waveform icons-list" @click="msgEmConstrucao"></i>
      <div class="row">
        <span style="text-align: center">Histórico CSI</span>
      </div>
    </div>
    <div class="col col-icon">
      <i class="fa-sharp fa-solid fa-file-lines icons-list" @click="msgEmConstrucao"></i>
      <div class="row">
        <span>Historico juntada Médica</span>
      </div>
    </div>
    <div class="col col-icon" @click="openDialogFinalizarAtendimento()">
      <i class="fa-sharp fa-solid fa-check icons-list"></i>
      <div class="row">
        <span style="text-align: center">Finalizar o Atendimento</span>
      </div>
    </div>
  </div>

  <Dialog
    header="Form Paciente"
    v-model:visible="showEventCreationDialog"
    style="
       {
        width: 60vw;
        backgroundcolor: #dcdeff;
      }
    "
    id="pacientes"
  >
    <component v-bind:is="formPacienteMilitar" v-if="paciM" :idPac="paciente.id"></component>
    <component v-bind:is="formPacienteDependente" v-if="paciD" :idPac="paciente.id"></component>
  </Dialog>

  <a-modal v-model:visible="showEventRepassePac" title="Repasse do Paciente" :width="'1200px'">
    <template #footer>
      <a-button type="primary" @click="fecharModal">Fechar</a-button>
    </template>
    <!-- <component v-bind:is="repasseAtendimentoPaciente." :registroAtendimento="registroAtendimento"></component> -->
    <component v-bind:is="repasseAtendimentoPaciente" :paciente="paciente"></component>

    <!--    </Dialog>-->
  </a-modal>

  <Dialog
    header="Dados de Inserção"
    v-model:visible="showInsercaoDadosDialog"
    style="
       {
        width: 90vw;
        backgroundcolor: #dcdeff;
      }
    "
    id="dadosInsercao"
  >
    <div class="row" style="margin-top: 10px">
      <div class="col-6">
        <div class="row">
          <div class="col">
            <label for="formFileSm" class="form-label">Tipo Documento</label>
            <select class="form-select" ref="tipoDocumento">
              <option v-for="item in enumTipoDocumento" :key="item" :value="item.tipo">
                {{ item.descricao }}
              </option>
            </select>
          </div>
          <div class="col">
            <label for="formFileSm" class="form-label">Importar Arquivo</label>
            <input class="form-control form-control-sm" id="formFileSm" type="file" name="file" ref="files" multiple v-on:change="uploadFile" />
          </div>
        </div>
      </div>
      <div class="col">
        <a-table :dataSource="paciente.documentos" :columns="columnsDocuments">
          <template #nomeArquivo="{ record }">
            <span>{{ record.nomeArquivo }}</span>
          </template>
          <template #tipoDocumento="{ record }">
            <span>{{ stringTipoDocumento(record) }}</span>
          </template>
          <template #action="{ record }">
            <a-tooltip title="Imprimir" placement="top">
              <i class="far fa-file-alt" style="margin-right: 5px; cursor: pointer" @click="baixarArquivo(record)"></i>
            </a-tooltip>
            <a-tooltip title="Remover" placement="top">
              <a @click="removeDataArchive(record)"><i class="fas fa-trash icon-trash"></i></a>
            </a-tooltip>
          </template>
          <template>
            <a-pagination :total="500" />
          </template>
        </a-table>
      </div>
    </div>
  </Dialog>

  <a-modal @cancel="cancelarFinalizacaoAtendimento()" v-model:visible="showFinalizarAtendimentoDialog" title="Finalizar o Atendimento" width="700px">
    <div class="row" style="margin-bottom: 15px">
      <div class="col-md-12">
        <label for="tipoAgenda">Situação do Atendimento</label>
        <select class="form-select form-input-component" v-model="situacaoAtendimento" required v-bind:class="{ 'is-invalid': submittedFinalizarAtendimento && !situacaoAtendimento }" id="situacaoAtendimento">
          <option value="Atendido">Atendido</option>
          <option value="Não compareceu - Falta justificada">Não compareceu - Falta justificada</option>
          <option value="Não compareceu - Falta injustificada">Não compareceu - Falta injustificada</option>
        </select>
      </div>
    </div>

    <template #footer>
      <button type="button" class="btn btn-primary" @click="finalizarAtendimento()">Salvar</button>
      <button type="button" class="btn btn-primary" @click="cancelarFinalizacaoAtendimento()">Cancelar</button>
    </template>
  </a-modal>

  <Dialog
    header="Funçoes"
    v-model:visible="showEventFuncoesDialog"
    style="
       {
        width: 60vw;
        backgroundcolor: #dcdeff;
      }
    "
    id="funcoes"
  >
    <a-table :dataSource="dataFuncoes" :columns="columnsFuncoes">
      <template #orgaoInterno="{ record }">
        <span>N/A {{ record.orgaoInterno }}</span>
      </template>
      <template #dtInicio="{ record }">
        <span>{{ formataData(record.dtInicio) }}</span>
      </template>
      <template #btInicio="{ record }">
        <span>N/A {{ record.btInicio }}</span>
      </template>
      <template #dtFim="{ record }">
        <span>{{ formataData(record.dtFim) }}</span>
      </template>
      <template #btFim="{ record }">
        <span>N/A {{ record.btFim }}</span>
      </template>
    </a-table>
  </Dialog>

  <ul class="nav nav-tabs nav-justified mb-3" id="ex1" role="tablist">
    <li class="nav-item" role="presentation">
      <a class="nav-link active" id="ex3-tab-1" data-bs-toggle="tab" href="#ex3-tabs-1" role="tab" aria-controls="ex3-tabs-1" aria-selected="true">Acompanhamento</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="ex3-tab-2" data-bs-toggle="tab" href="#ex3-tabs-2" role="tab" aria-controls="ex3-tabs-2" aria-selected="false">Pergunta</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="ex3-tab-3" data-bs-toggle="tab" href="#ex3-tabs-3" role="tab" aria-controls="ex3-tabs-3" aria-selected="false">Formulário</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="ex3-tab-4" data-bs-toggle="tab" href="#ex3-tabs-4" role="tab" aria-controls="ex3-tabs-3" aria-selected="false">Anexos</a>
    </li>
    <li class="nav-item" role="presentation">
      <a class="nav-link" id="ex3-tab-5" data-bs-toggle="tab" href="#ex3-tabs-5" role="tab" aria-controls="ex3-tabs-3" aria-selected="false">Gerar Documentos</a>
    </li>
  </ul>

  <div class="tab-content" id="ex2-content">
    <div class="tab-pane fade show active" id="ex3-tabs-1" role="tabpanel" aria-labelledby="ex3-tab-1">
      <component v-bind:is="atendimentoAcompanhamento"></component>
    </div>
    <div class="tab-pane fade" id="ex3-tabs-2" role="tabpanel" aria-labelledby="ex3-tab-2">
      <component v-bind:is="atendimentoPergunta"></component>
    </div>
    <div class="tab-pane fade" id="ex3-tabs-3" role="tabpanel" aria-labelledby="ex3-tab-3">
      <component v-bind:is="formularioAtendimento"></component>
    </div>
    <div class="tab-pane fade" id="ex3-tabs-4" role="tabpanel" aria-labelledby="ex3-tab-4">
      <component v-bind:is="anexoDocumentoAcompanhamento"></component>
    </div>
    <div class="tab-pane fade" id="ex3-tabs-5" role="tabpanel" aria-labelledby="ex3-tab-5">
      <component v-bind:is="gerarDocumento" :registroAtendimento="registroAtendimento"></component>
    </div>
  </div>
</template>

<script>
import { createPaciente, getPacienteById } from '@/components/service/pacienteService';
import { getByIdAgendamento } from '@/components/service/agendamento-medico';
import { updateAgendamento } from '@/components/service/agendamento-medico';
import FormPacienteMilitar from '@/components/pages/pages-paciente/FormPacienteMilitar';
import FormPacienteDependente from '@/components/pages/pages-paciente/FormPacienteDependente';
import { getFuncoesCpfPM } from '@/config/servicos-utils';
import { formatarData } from '@/utils/servicos-utils';
import { EnumTipoDocumento } from '@/components/models/enumTipoDocumento';
import { EnumSituacaoAgendamento } from '@/components/models/enumSituacaoAgendamento';
import { downloadDocumentFileWs, isArquivoValido, sendDocumentFileWs } from '@/utils/filews';
import { openNotification, typesNotification } from '@/utils/notifications';
import AtendimentoAcompanhamento from '@/components/pages/pages-atendimento/AtendimentoAcompanhamento';
import { getByIdRegistroAtendimento } from '@/components/service/registroAtendimentoService';
import AnexoDocumentoAcompanhamento from '@/components/pages/pages-atendimento/AnexoDocumentoAcompanhamento';
import AtendimentoPergunta from '@/components/pages/pages-atendimento/AtendimentoPergunta.vue';
import FormularioAtendimento from '@/components/pages/pages-atendimento/FormularioAtendimento';
import RepasseAtendimentoPaciente from '@/components/pages/pages-atendimento/RepasseAtendimentoPaciente';
import { getDataUser } from '@/utils';
import GerarDocumento from '@/components/pages/pages-atendimento/GerarDocumento';

export default {
  name: 'PageAcompanhamento',
  components: {
    FormPacienteMilitar,
    FormPacienteDependente,
    AnexoDocumentoAcompanhamento,
    AtendimentoAcompanhamento,
    FormularioAtendimento,
    RepasseAtendimentoPaciente,
    GerarDocumento,
  },
  data() {
    return {
      registroAtendimento: null,
      agendamentoMedico: null,
      idRegistro: null,
      paciente: null,
      paciM: false,
      dataUser: getDataUser(),
      paciD: false,
      formPacienteMilitar: FormPacienteMilitar,
      formPacienteDependente: FormPacienteDependente,
      atendimentoAcompanhamento: AtendimentoAcompanhamento,
      anexoDocumentoAcompanhamento: AnexoDocumentoAcompanhamento,
      gerarDocumento: GerarDocumento,
      atendimentoPergunta: AtendimentoPergunta,
      formularioAtendimento: FormularioAtendimento,
      repasseAtendimentoPaciente: RepasseAtendimentoPaciente,
      showEventCreationDialog: false,
      showInsercaoDadosDialog: false,
      showFinalizarAtendimentoDialog: false,
      showEventFuncoesDialog: false,
      showEventRepassePac: false,
      enumTipoDocumento: [],
      enumSituacaoAgendamento: EnumSituacaoAgendamento(),
      situacaoAtendimento: undefined,
      submittedFinalizarAtendimento: false,
      dataFuncoes: [],
      columns: [
        {
          title: 'Data',
          dataIndex: 'data',
          key: 'data',
          slots: { customRender: 'data' },
        },
        {
          title: 'Acompanhamentos',
          dataIndex: 'acompanhamentos',
          key: 'acompanhamentos',
          slots: { customRender: 'acompanhamentos' },
        },
      ],
      columnsFuncoes: [
        {
          title: 'Função',
          dataIndex: 'funcaoNome',
          key: 'funcaoNome',
          slots: { customRender: 'funcaoNome' },
        },
        {
          title: 'Orgãos Internos',
          dataIndex: 'orgaoInterno',
          key: 'orgaoInterno',
          slots: { customRender: 'orgaoInterno' },
        },
        {
          title: 'Unidade',
          dataIndex: 'unidadeNome',
          key: 'unidadeNome',
          slots: { customRender: 'unidadeNome' },
        },
        {
          title: 'Data Início',
          dataIndex: 'dtInicio',
          key: 'dtInicio',
          slots: { customRender: 'dtInicio' },
        },
        {
          title: 'Boletim Início',
          dataIndex: 'btInicio',
          key: 'btInicio',
          slots: { customRender: 'btInicio' },
        },
        {
          title: 'Data Fim',
          dataIndex: 'dtFim',
          key: 'dtFim',
          slots: { customRender: 'dtFim' },
        },
        {
          title: 'Boletim Fim',
          dataIndex: 'btFim',
          key: 'btFim',
          slots: { customRender: 'btFim' },
        },
      ],
      columnsDocuments: [
        {
          title: 'Tipo Documento',
          dataIndex: 'tipoDocumento',
          key: 'tipoDocumento',
          slots: { customRender: 'tipoDocumento' },
        },
        {
          title: 'Arquivo',
          dataIndex: 'nomeArquivo',
          key: 'nomeArquivo',
          slots: { customRender: 'nomeArquivo' },
        },
        {
          title: 'Ações',
          dataIndex: 'action',
          key: 'action',
          slots: { customRender: 'action' },
        },
      ],
    };
  },
  async created() {
    this.idRegistro = this.$route.query.id;
    await getByIdRegistroAtendimento(this.idRegistro).then(async (r) => {
      this.registroAtendimento = r.data;
      this.paciente = r.data.agendamentoMedico.paciente;
      this.dataDocuments = this.paciente.documentos;
      await getByIdAgendamento(r.data.agendamentoMedico.id).then(async (r) => {
        this.agendamentoMedico = r.data;
        this.agendamentoMedico.situacao = this.enumSituacaoAgendamento.find((sa) => sa.tipo === r.data.situacao).descricao;
      });
      if (this.dataUser.cpf !== this.registroAtendimento.agendamentoMedico.profissional.cpf) {
        this.$router.push({ path: '/gerir-atendimento-visao-profissional' });
      }
    });
  },
  methods: {
    msgEmConstrucao() {
      openNotification(typesNotification.info, 'Funcionalidade em Construção');
    },

    async openDialogPac() {
      if (this.paciente.tipoPaciente === 'MILITAR') {
        this.showEventCreationDialog = true;
        this.paciM = true;
      } else {
        this.showEventCreationDialog = true;
        this.paciD = true;
      }
    },
    async openDialogInsercaoDados() {
      await this.getTipoDocumento();
      await getPacienteById(this.paciente.id).then((p) => {
        this.paciente.documentos = p.data.documentos;
        this.showInsercaoDadosDialog = true;
      });
    },
    async openDialogFinalizarAtendimento() {
      if (this.agendamentoMedico.situacao !== 'Agendado' && this.agendamentoMedico.situacao !== 'Em Atendimento' && this.agendamentoMedico.situacao !== 'Aguardando atendimento') {
        openNotification(typesNotification.warning, 'O Atendimento já se encontra finalizado!');
        return;
      }
      this.showFinalizarAtendimentoDialog = true;
    },
    async cancelarFinalizacaoAtendimento() {
      this.showFinalizarAtendimentoDialog = false;
      this.situacaoAtendimento = undefined;
      this.submittedFinalizarAtendimento = false;
    },

    async finalizarAtendimento() {
      this.submittedFinalizarAtendimento = true;
      if (this.situacaoAtendimento === undefined) {
        openNotification(typesNotification.warning, 'Selecione uma situação para finalizar o atendimento!');
        return;
      }

      this.updateAgendamento();
    },
    async updateAgendamento() {
      await updateAgendamento({ id: this.agendamentoMedico.id, tipoAtendimento: null, situacao: this.situacaoAtendimento }).then(async () => {
        this.agendamentoMedico.situacao = this.situacaoAtendimento;
        this.cancelarFinalizacaoAtendimento();
        openNotification(typesNotification.success, 'Atendimento finalizado com sucesso!');
      });
    },
    async abrirFuncoes() {
      await getFuncoesCpfPM(this.paciente.cpf).then((r) => {
        this.dataFuncoes = r.data;
        this.showEventFuncoesDialog = true;
      });
    },
    async abrirRepasse() {
      this.showEventRepassePac = true;
    },
    formataData(data) {
      return formatarData(new Date(data), 'DD/MM/YYYY');
    },
    getTipoDocumento() {
      this.enumTipoDocumento = EnumTipoDocumento();
    },
    async uploadFile() {
      let validarTamanho = isArquivoValido('', '', this.$refs.files.files[0].size, true);
      if (this.$refs.tipoDocumento.value) {
        if (validarTamanho.tamanho) {
          await sendDocumentFileWs(this.$refs.files.files[0], 'TOKEN', 'ssp').then((r) => {
            const obj = {
              idAnexoFileWs: r.data.id,
              tipoDocumento: this.$refs.tipoDocumento.value,
              nomeArquivo: r.data.nomeOriginal,
            };
            this.paciente.documentos.push(obj);
            this.saveAndContinue();
            openNotification(typesNotification.success, 'Arquivo enviado com sucesso');
          });
        } else {
          openNotification(typesNotification.error, 'Tamanho de arquivo não suportado.');
        }
      }
    },
    async baixarArquivo(document) {
      await downloadDocumentFileWs(document.idAnexoFileWs, document.nomeArquivo);
    },
    stringTipoDocumento(documento) {
      let tipoDoc = this.enumTipoDocumento.find((etp) => etp.tipo === documento.tipoDocumento || etp.descricao === documento.tipoDocumento);
      if (tipoDoc) {
        return tipoDoc.descricao;
      }
    },
    removeDataArchive(record) {
      this.paciente.documentos.splice(this.paciente.documentos.indexOf(this.paciente.documentos.find((r) => r.idAnexoFileWs === record.idAnexoFileWs)), 1);
      this.saveAndContinue();
    },
    async saveAndContinue() {
      await createPaciente(this.paciente).then((r) => {
        this.paciente = r.data;
        openNotification(typesNotification.success, 'Dados salvos com sucesso.');
      });
    },
    fecharModal() {
      this.showEventRepassePac = false;
    },
  },
};
</script>

<style scoped>
.icons-list {
  font-size: 30px;
  margin-left: 38%;
}

.col-icon {
  transition: transform 0.2s;
  cursor: pointer;
}

.col-icon:hover {
  transform: scale(1.1);
}

.icons-list:hover {
  color: #03315f;
  text-shadow: 0 0 3px #03315f;
}

.horizontal-center {
  margin: 0 auto;
}
</style>
